module.exports = ["только что",["%s секунда назад","%s секунд назад"],["%s минута назад","%s минут назад"],["%s час назад","%s часов назад"],["%s день назад","%s дней назад"],["%s неделя назад","%s недель назад"],["%s месяц","%s месяцев назад"],["%s год назад","%s лет назад"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/ru-RU.json
// module id = KtA6
// module chunks = 1